import {
  getEmptyMdfActivityOutcomeForm,
  IMdfActivityOutcomeForm,
  mapMdfActivityToOutcomeForm,
} from '../../../lib'
import { IMdfActivity } from '../../../model/types'

/**
 * Shape seeded into the cng-common form. `outcome` is a JSON-encoded item list
 * in the existing MDF field; the outcome metrics stay nullable
 * numbers to match `FormNumberInput`'s `Nullable<number>` value type.
 */
export type TMdfDetailsForm = IMdfActivityOutcomeForm

export { getEmptyMdfActivityOutcomeForm }

export const getInitialFormData = (activity: IMdfActivity): TMdfDetailsForm =>
  mapMdfActivityToOutcomeForm(activity)
